import { getTimeZones } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export const useGetTimeZones = (tenantId: string) => {
  const { data, status, refetch } = useQuery(
    ['timeZonesOptions'],
    () => getTimeZones(tenantId),
    { staleTime: 300000 }
  );

  return {
    timeZones: data?.data || [],
    timeZonesStatus: status,
    fetchTimeZones: refetch,
  };
};
